<template>
  <b-card>
    <!-- Modal -->
    <b-modal
      modal-class="oderDetail"
      v-model="dialog"
      size="lg"
      :title="modalTitle"
      ok-title="Close"
      header-close-content=""
      ok-only
    >
      <b-container>
        <!-- <div class="text-center" v-if="isLoading">
          <b-spinner variant="primary" label="Spinning"></b-spinner>
        </div> -->
        <div class="d-flex flex-column justify-content-between w-100 oderDetailBody">
          <div class="oderDetailContent">
            <b-card class="section-body">
              <!-- {{ viewItems }} -->

              <div class="ticketItemContent ticketItemContentAcc">
                <div class="transaction-info">
                  <div class="transaction-info-row row d-flex">
                    <div
                      class="transaction-info-item transaction-info-item-account col-4"
                      v-for="(value, key) in raw_data"
                      :key="key"
                    >
                      <div class="item-title text-capitalize">
                        {{ key.replaceAll('_', ' ') }}
                      </div>
                      <!-- <div class="item-value" v-if="key === 'notify_time'">
                        {{ value ? formatDateForView(value) : "null" }}
                      </div> -->
                      <div class="item-value">
                        {{ value ? value : 'null' }}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </b-card>
          </div>
        </div>
      </b-container>
    </b-modal>
    <!-- Header -->
    <b-row class="table-filter">
      <b-col cols="12">
        <h4 class="b-card-title">Notification List</h4>
      </b-col>
      <!-- filter_phone -->
      <b-col>
        <b-form-group id="input-amount-filter" label="Account" label-for="amount-filter">
          <b-form-input
            trim
            id="amount-filter"
            v-model="filter_phone"
            type="text"
            min="0"
            placeholder="Search account..."
            @input="onFilterName"
          ></b-form-input>
        </b-form-group>
      </b-col>
      <!-- FilterGame -->
      <b-col>
        <b-form-group id="input-game-filter" label="Notifications" label-for="game-filter">
          <b-form-select id="game-filter" v-model="filter_action" :options="allGameList" @change="fetchData">
            <template v-slot:first>
              <b-form-select-option :value="null">All</b-form-select-option>
            </template>
          </b-form-select>
        </b-form-group>
      </b-col>
      <!-- Filter Active -->
      <b-col>
        <b-form-group id="input-status-filter" label="Status" label-for="status-filter">
          <b-form-select id="status-filter" v-model="filter_status" :options="statusList" @change="fetchData">
            <template v-slot:first>
              <b-form-select-option :value="null">All</b-form-select-option>
            </template></b-form-select
          >
        </b-form-group>
      </b-col>
      <!-- Filter Active -->
      <b-col>
        <b-form-group id="input-status-filter" label="Viewed Notify" label-for="status-filter">
          <b-form-select
            id="status-filter"
            v-model="filter_viewed_notify"
            :options="viewedNotifyList"
            @change="fetchData"
          >
            <template v-slot:first>
              <b-form-select-option :value="null">All</b-form-select-option>
            </template></b-form-select
          >
        </b-form-group>
      </b-col>
    </b-row>
    <!-- Table -->
    <b-table
      striped
      :fields="headers"
      :items="items"
      :busy="isBusy"
      :current-page="currentPage"
      responsive
      bordered
      class="elevation-1 data-table text-center orderTable"
    >
      <template v-slot:cell(notification_action)="item">
        {{ item.item.notification_action.title }}
      </template>
      <template v-slot:cell(status)="item">
        <b-badge class="mr-1" v-if="item.value === 1" variant="success">Active</b-badge>
        <b-badge class="mr-1" v-else-if="item.value === 0 && item.item.deleted_at" variant="danger">Deleted</b-badge>
        <b-badge class="mr-1" v-else-if="item.value === 0" variant="warning">Inactive</b-badge>
      </template>
      <template v-slot:cell(rawData)="item">
        <v-icon class="text-success" @click="viewItem(item.item)">mdi-eye</v-icon>
      </template>
    </b-table>
    <!-- Footer -->
    <b-row>
      <b-col cols="5">
        Showing {{ (currentPage - 1) * perPage + 1 }}-{{
          currentPage * perPage > rows ? rows : currentPage * perPage
        }}
        of {{ rows }}.
      </b-col>
      <b-col style="display: flex; justify-content: flex-end">
        <b-form-group
          id="input-per-page"
          label="Rows per page: "
          label-for="per-page"
          label-cols="8"
          style="margin-right: 20px; margin-bottom: 0"
        >
          <b-form-select
            id="per-page"
            v-model="perPage"
            size="sm"
            :options="[5, 10, 15, 20]"
            style="width: 65px"
            @change="fetchData"
          ></b-form-select>
        </b-form-group>
        <b-pagination
          v-model="currentPage"
          :total-rows="rows"
          :per-page="perPage"
          aria-controls="my-table"
          align="right"
          v-on:input="fetchData"
        ></b-pagination>
      </b-col>
    </b-row>
  </b-card>
</template>
<script>
import { SET_BREADCRUMB } from '@/store/breadcrumbs.module';
import ApiService from '@/common/api.service.js';
import _ from 'lodash';
import axios from 'axios';
import { formatDateForView } from '@/utils/time.js';
export default {
  name: 'Noti List',
  components: {},
  data() {
    return {
      isLoading: true,
      search: '',
      isBusy: false,
      filter_phone: '',
      filter_time: '',
      filter_action: null,
      filter_shipping_id: null,
      filter_status: null,
      filter_viewed_notify: null,
      statusList: [
        { value: 1, text: 'Active' },
        { value: 0, text: 'Inactive' }
      ],
      viewedNotifyList: [
        { value: 1, text: 'Seen' },
        { value: 0, text: 'Not Seen' }
      ],
      headers: [
        { text: 'Account', key: 'account' },
        { text: 'notify_time', key: 'notify_time' },
        { text: 'target_url', key: 'target_url' },
        { text: 'notification_action', key: 'notification_action' },
        { text: 'Status', key: 'status', class: 'text-center' },
        { text: 'Raw Data', key: 'rawData', class: 'text-center' }
      ],
      // Modal data
      items: [],
      allGameList: [],
      modalTitle: '',
      // Modal validate
      rows: 0,
      perPage: 10,
      currentPage: 1,
      editedItem: {
        id: '',
        action_id: '',
        account_id: '',
        target_url: '',
        raw_data: '',
        notify_time: '',
        viewed_notify: '',
        status: '',
        notification_action: {
          title: ''
        },
        account: ''
      },
      dialog: false,
      editedIndex: -1,
      orderDetail: [],
      raw_data: []
    };
  },
  watch: {
    dialog(val) {
      val || this.close();
    },
    editedItem: function (newVal, oldVal) {
      if (newVal != oldVal) {
        this.editedItem = newVal;
      }
    }
  },
  computed: {},
  created() {
    this.fetchData();
  },
  mounted() {
    this.$store.dispatch(SET_BREADCRUMB, [
      // {
      //   title: "Product",
      //   route: "product-list"
      // },
      { title: 'Notification List' }
    ]);
  },
  methods: {
    onFilterName: _.debounce(function () {
      this.fetchData();
    }, 500),
    fetchData() {
      this.isBusy = true;
      let limit = this.perPage;
      let offset = this.currentPage;
      ApiService.setHeader();
      const asdNotifications = ApiService.get(
        'notifications',
        `?&action=${this.filter_action || ''}&phone=${this.filter_phone || ''}&notify_time=${
          this.filter_time || ''
        }&status=${this.filter_status == null ? '' : this.filter_status}&viewed_notify=${
          this.filter_viewed_notify == null ? '' : this.filter_viewed_notify
        }&limit=${limit}&offset=${offset}`
      );
      const allNotiaction = ApiService.get('allnotiaction');
      axios
        .all([asdNotifications, allNotiaction])
        .then(
          axios.spread((...response) => {
            const adsProductRes = response[0];
            const allNotiactionRes = response[1];
            this.items = adsProductRes.data.data.notiList.map((ads) => {
              return {
                ...ads,
                notify_time: formatDateForView(new Date(ads.notify_time).toISOString())
              };
            });
            this.rows = adsProductRes.data.data.total;
            this.allGameList = allNotiactionRes.data.data;
            this.isBusy = false;
          })
        )
        .catch((errors) => {
          this.$bvToast.toast(`${errors}`, {
            title: null,
            variant: 'danger',
            autoHideDelay: 3000,
            noCloseButton: true
          });
          this.isBusy = false;
        });
    },
    viewItem: function (item) {
      this.dialog = true;
      this.editedIndex = this.items.indexOf(item);
      this.modalTitle = `Raw Data`;
      this.editedItem = {
        ...item
      };
      this.raw_data = JSON.parse(item.raw_data);
      if (this.raw_data.lottery_time) {
        this.raw_data.lottery_time = formatDateForView(this.raw_data.lottery_time);
      }
      this.filter_status = item.status;
    },

    close() {
      this.dialog = false;
      // this.editedItem = Object.assign({}, this.defaultItem);
      this.editedItem = {
        id: '',
        reward_amount: '',
        status: '',
        display_reward_id: '',
        account: {
          id: '',
          name: ''
        },
        product_reward: {
          correct_slots: '',
          jackpott: ''
        },
        order_detail: {
          raw_data: '',
          period_name: '',
          price: '',
          ticket_name: '',
          game: {
            name: ''
          },
          product: {
            name: ''
          }
        }
      };
      this.editedIndex = -1;
      this.filter_status = null;
    }
  }
};
</script>

<style lang="scss">
.oderDetail {
  .oderDetailBody {
    .oderDetailContent {
      .card {
        border: unset !important;
      }
    }
  }
}
</style>
